import React from 'react';

import { buttons, colors } from '@pray/shared/components/foundations';
import Button from '@pray/shared/components/ui/Button';

import { PRODUCT_LABELS, Products } from 'components/pages/public/types/products';
import useAppRoutes from 'hooks/useAppRoutes';

import type { ReadyToGoGlobalSectionProps } from '../types';

const ReadyToGoGlobalSection: React.FC<ReadyToGoGlobalSectionProps> = ({ onClick }) => {
  const appRoutes = useAppRoutes();
  return (
    <section className="py-16">
      <div className="mx-auto flex max-w-7xl flex-col items-center gap-6 text-center md:gap-8 ">
        <div className="flex  flex-col items-center gap-5 text-center">
          <h2 className="text-[2.5rem] font-[650] leading-[3rem] text-pray-secondary md:text-[3.5rem] md:leading-[4rem]">
            Ready to Go Global?
          </h2>
          <p className="mx-auto max-w-3xl text-base font-[450] text-text-secondary">
            Join thousands of speakers, preachers, and visionaries utilizing {PRODUCT_LABELS[Products.PRAYSTUDIO]} to
            reach new audiences around the world.
          </p>
        </div>
        <Button
          data-tapeventname="Ready to Go Global CTA"
          to={appRoutes.getStarted()}
          variant={buttons.variant.primary}
          color={colors.pray_featured}
          className="font-[650]"
          onClick={onClick}
        >
          GET STARTED
        </Button>
      </div>
    </section>
  );
};

export default ReadyToGoGlobalSection;
